import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';


import translationEN from './locales/en/translation.json';
import translationTA from './locales/ta/translation.json';
import translationES from './locales/es/translation.json';
import translationFR from './locales/fr/translation.json';
import translationDE from './locales/de/translation.json';
import translationHI from './locales/hi/translation.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    ta: {
        translation: translationTA
    },
    es: {
        translation: translationES
    },
    fr: {
        translation: translationFR
    },
    de: {
        translation: translationDE
    },
    hi: {
        translation: translationHI
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

export default i18n;
